/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No voices match your filters." |
*
* @param {Voice_Manager_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_no_results = /** @type {((inputs?: Voice_Manager_No_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_No_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune voix ne correspond à vos filtres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Stimmen entsprechen Ihren Filtern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna voce corrisponde ai filtri.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет голосов, соответствующих фильтрам.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ninguna voz coincide con tus filtros.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有符合筛选条件的语音。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルターに一致する音声はありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपके फ़िल्टर से कोई आवाज़ मेल नहीं खाती।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma voz corresponde aos filtros.")
	return /** @type {LocalizedString} */ ("No voices match your filters.")
});